import './bootstrap';

// Base
import '@wielink-application/shared/js/vue.js'